function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "57.036px",
    height: "42.383px",
    viewBox: "0 0 57.036 42.383",
    style: {
      enableBackground: "new 0 0 57.036 42.383"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.3037,
    y1: 22.0366,
    x2: 22.5177,
    y2: 59.8227
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M54.533,29.611l-3.693-1.535c-0.764-0.317-1.643,0.045-1.961,0.81s0.045,1.643,0.81,1.961 l3.692,1.535c0.188,0.078,0.384,0.115,0.576,0.115c0.588,0,1.146-0.348,1.385-0.925C55.66,30.807,55.298,29.929,54.533,29.611z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.0947,
    y1: 17.8281,
    x2: 18.3086,
    y2: 55.6143
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M57.023,19.915c-0.106-0.82-0.863-1.4-1.682-1.293l-3.965,0.518 c-0.822,0.107-1.4,0.86-1.293,1.682c0.098,0.756,0.742,1.307,1.484,1.307c0.065,0,0.131-0.004,0.197-0.014l3.965-0.518 C56.553,21.49,57.131,20.737,57.023,19.915z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.624,
    y1: 11.3569,
    x2: 11.8382,
    y2: 49.1428
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M52.372,11.084c0.658-0.504,0.784-1.445,0.28-2.104c-0.504-0.657-1.444-0.783-2.103-0.279 l-3.177,2.43c-0.658,0.503-0.783,1.444-0.28,2.102c0.296,0.387,0.741,0.59,1.192,0.59c0.318,0,0.639-0.102,0.91-0.309 L52.372,11.084z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.9746,
    y1: -1.2915,
    x2: -0.8108,
    y2: 36.4939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M30.969,5.662c0.098,0.756,0.742,1.306,1.484,1.306c0.064,0,0.131-0.004,0.196-0.012 c0.821-0.107,1.4-0.859,1.294-1.682l-0.518-3.966c-0.106-0.821-0.856-1.407-1.681-1.294c-0.821,0.107-1.4,0.859-1.294,1.682 L30.969,5.662z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1846,
    y1: -4.0825,
    x2: -3.6019,
    y2: 33.704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M22.96,9.665c0.295,0.386,0.741,0.588,1.192,0.588c0.318,0,0.638-0.1,0.91-0.309 c0.658-0.503,0.784-1.444,0.28-2.102l-2.43-3.178c-0.503-0.657-1.444-0.781-2.103-0.279c-0.658,0.503-0.784,1.444-0.28,2.102 L22.96,9.665z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.626,
    y1: 4.3589,
    x2: 4.8383,
    y2: 42.1465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M40.711,8.161c0.188,0.078,0.383,0.115,0.576,0.115c0.587,0,1.145-0.348,1.385-0.924 l1.537-3.693c0.318-0.764-0.044-1.643-0.809-1.961c-0.766-0.318-1.644,0.043-1.961,0.809L39.902,6.2 C39.584,6.963,39.945,7.842,40.711,8.161z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.6182,
    y1: 8.3511,
    x2: 8.8318,
    y2: 46.1374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M46.582,21.026c-0.792-6.084-6.009-10.672-12.135-10.672c-0.529,0-1.066,0.035-1.594,0.104 c-2.945,0.384-5.497,1.803-7.373,3.828c-1.327-0.488-2.755-0.758-4.24-0.758c-5.878,0-10.868,4.262-11.982,9.857 C4.131,23.514,0,27.725,0,32.883c0,4.158,2.781,7.898,6.713,9.08c0.845,0.278,1.719,0.42,2.6,0.42h25.256 c0.965,0,1.923-0.173,2.848-0.514c4.469-1.43,7.468-5.537,7.468-10.236c0-0.783-0.089-1.545-0.249-2.281 C46.21,26.982,46.977,24.063,46.582,21.026z M36.164,38.071l-0.102,0.035c-0.49,0.184-0.992,0.277-1.494,0.277H9.312 c-0.454,0-0.907-0.074-1.397-0.235C5.61,37.456,4,35.291,4,32.883c0-3.033,2.467-5.5,5.5-5.5c0.375,0,0.754,0.038,1.125,0.115 l2.354,0.484l0.049-2.403c0.09-4.44,3.774-8.052,8.212-8.052c3.828,0,7.113,2.605,7.991,6.336l0.513,2.182l2.109-0.758 c0.748-0.269,1.516-0.404,2.28-0.404c3.722,0,6.75,3.027,6.75,6.75C40.884,34.595,38.987,37.182,36.164,38.071z M34.134,20.883 c-0.547,0-1.093,0.043-1.636,0.127c-0.765-1.835-1.954-3.413-3.429-4.646c1.177-1.019,2.645-1.724,4.3-1.939 c0.357-0.047,0.721-0.07,1.078-0.07c4.123,0,7.635,3.091,8.168,7.188c0.145,1.111,0.052,2.197-0.227,3.216 C40.415,22.392,37.448,20.883,34.134,20.883z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.496e8fc7d3477e6f5f981830dc10b8dd.svg";
export { ForwardRef as ReactComponent };